export class JobConstants {
    private static _JOB_TYPES: Object = {
        'DataProtectionServiceJob': 'activityLog.constants.jobType.dataProtection',
        'NetworkingLifecycleJob' : 'activityLog.constants.jobType.advancedNetworking',
        'VcdDpsJob': 'activityLog.constants.jobType.dataProtection',
        'NetworkingServiceJobV1': 'activityLog.constants.jobType.networking',
        'NetworkingServiceJobV2': 'activityLog.constants.jobType.networking',
        'DirectConnectJob': 'activityLog.constants.jobType.directConnect',
        'ComputeJob': 'activityLog.constants.jobType.compute',
        'HybridDMZServiceJob': 'activityLog.constants.jobType.hybridDMZService'
    };
    public static get JOB_TYPES(): Object {
       return JobConstants._JOB_TYPES;
    }

    private static _WORKFLOW_TYPES: Object = {
        'VM_ADHOC_BACKUP_WORKFLOW': 'activityLog.constants.workflowType.vmBackup',
        'VM_SCHEDULE_BACKUP_WORKFLOW': 'activityLog.constants.workflowType.vmPolicy',
        'VM_RESTORE_WORKFLOW': 'activityLog.constants.workflowType.vmRestore',
        'RESOURCE_POOL_SCHEDULE_BACKUP_WORKFLOW': 'activityLog.constants.workflowType.resourcePoolPolicy',
        'NETWORK_CREATE': 'activityLog.constants.workflowType.networkCreate',
        'NETWORK_UPDATE': 'activityLog.constants.workflowType.networkUpdate',
        'NETWORK_DELETE': 'activityLog.constants.workflowType.networkDelete',
        'GATEWAY_CREATE': 'activityLog.constants.workflowType.gatewayCreate',
        'GATEWAY_UPDATE': 'activityLog.constants.workflowType.gatewayUpdate',
        'GATEWAY_DELETE': 'activityLog.constants.workflowType.gatewayDelete',
        'GATEWAY_ACTION': 'activityLog.constants.workflowType.gatewayAction',
        'GATEWAY_FORCESYNC': 'activityLog.constants.workflowType.gatewayForcesync',
        'GATEWAY_REDEPLOY': 'activityLog.constants.workflowType.gatewayRedeploy'
    };
    public static get WORKFLOW_TYPES(): Object {
       return JobConstants._WORKFLOW_TYPES;
    }

    private static _SERVICES: Object = {
        'DataProtectionServiceJob': 'DataProtectionServiceJob',
        'VcdDpsJob': 'VcdDpsJob',
        'NetworkingLifecycleJob': 'NetworkingLifecycleJob',
        'NetworkingServiceJobV1': 'NetworkingServiceJobV1',
        'NetworkingServiceJobV2': 'NetworkingServiceJobV2',
        'DirectConnectJob': 'DirectConnectJob',
        'HybridDMZServiceJob': 'HybridDMZServiceJob'
    };
    public static get SERVICES(): Object {
       return JobConstants._SERVICES;
    }

    public static WORKFLOW_JOB_TYPES = {
        DEFAULT: 'DEFAULT',
        CREATE_ORGANIZATION_JOB: 'createOrganization',
        UPDATE_ORGANIZATION_JOB: 'updateOrganization',
        DELETE_ORGANIZATION_JOB: 'deleteOrganization',
        CREATE_ORG_VDC_JOB: 'createOrganizationVdc',
        UPDATE_ORG_VDC_JOB: 'updateOrganizationVdc',
        DELETE_ORG_VDC_JOB: 'deleteOrganizationVdc',
        UPDATE_ORG_VDC_STORAGE_PROFILES_JOB: 'updateOrganizationVdcStorageProfiles',
        CREATE_EDGE_GATEWAY_JOB: 'createEdgeGateway',
        UPDATE_EDGE_GATEWAY_JOB: 'updateEdgeGateway',
        DELETE_EDGE_GATEWAY_JOB: 'deleteEdgeGateway',
        NETWORK_IMPORT : 'NETWORK_IMPORT'
    }

    private static exclude_services_from_toast: Array<string> = ['NetworkingLifecycleJob']

    public static getServiceToExcludeFromToast(){
        return JobConstants.exclude_services_from_toast;
    }

}



// WEBPACK FOOTER //
// ./src/common/utils/job-constants.ts